// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CursorIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CursorIcon" ref={forwardedRef} {...props}>
      <path d="m12.445 11.445 5.354-2.53L2.596 2.903l6.01 15.203 2.463-5.21 3.76 3.76 1.414-1.414zm-3.716 2.892L5.264 5.57l8.765 3.466-3.599 1.7z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CursorIcon = /* @__PURE__ */ Object.assign(CursorIconComponent, {
  displayName: 'CursorIcon',
});
